import { BaSeLoading, BaSeParagraph, BaSeTheme } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import React from 'react';

import { useReport } from '../hook/useReport';
import { Header } from './header-style';

function HeaderReportDetail() {
  const { getRouteParam, navigateTo } = Sebrae.useSebraeRouter();
  const { getStepData, laoding } = useReport();
  const [data, setData] = React.useState({});
  const [erro, setErro] = React.useState();

  React.useEffect(() => {
    getStepData({ cpf: getRouteParam('cpf'), step: 'INTERVIEW_DATA' })
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        setErro(error);
        navigateTo(`/relatorio/`);
        console.log('deu erro', error);
      });
  }, [getRouteParam, navigateTo, getStepData]);

  if (laoding) {
    return (
      <Header>
        <BaSeLoading
          backgroundColor="#fff"
          description=""
          lightMode="default"
          shadowLevel={0}
          spinnerColor=""
          spinnerSize={24}
          text="Carregando…"
          textColor=""
        />
      </Header>
    );
  }
  return (
    <Header>
      {erro ? (
        <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
          Erro para carregar informações do relatório
        </BaSeParagraph>
      ) : (
        <>
          <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
            {`${data?.moduleName} - Relatório de Perfil do Participante`}
          </BaSeParagraph>

          <BaSeParagraph color={BaSeTheme.colors.gestao.cinza10} isBold>
            {data?.candidateName}
          </BaSeParagraph>
        </>
      )}
    </Header>
  );
}

export default HeaderReportDetail;
